import GATEWAYADMINMODAL from "../Modal/GatewayAdminModal";
import BACK from "../../../images/icon-back-b.svg"
import { Link,useNavigate } from 'react-router-dom'
import GatewayAdminModaAction from "../Modal/GatewayAdminModaAction"
import { useCookies } from 'react-cookie';
import { useState } from 'react';

interface ActionProps {
    controlID: string;
    prcKind: number;
    gatewayRecno: number;
    changeState: Function;
    getGatewaySensor: Function;
}

const TitleSection = (props: ActionProps) => {
    const [cookies] = useCookies(['authority']);
    const authority = cookies.authority;
    const navigate = useNavigate();

    return (
        <section className="page-head" id="page-head">
            <div className="page-head-block">
                <div className="page-name">
                <a onClick={() => navigate(-1)}><img src={BACK} alt="戻る" /></a>
                    <div className="page-name-label">
                        Gateway管理画面
                    </div>
                </div>
                <div className="page-option">
                    <GatewayAdminModaAction
                        controlID={""}
                        prcKind={props.prcKind}
                        gatewayRecno={props.gatewayRecno}
                        setState={props.changeState}
                        getGatewaySensor={props.changeState}
                    />
                </div>
            </div>
        </section>
    )
};
export default TitleSection;
